/**
 * 自定义工具库
 */
export {
};
// 继承ya模板目录下工具库
export * from '+/deps/utils';



// WEBPACK FOOTER //
// ./src/deps/utils.js